import { createContext, useContext } from 'react';
import type { AgentTableWorkspaceValue } from './AgentTableWorkspace';
import type { AgentPeriod } from './agentTracking.model';

// Keep context identity stable when the workspace's components hot-reload.
export const AgentTableContext = createContext<AgentTableWorkspaceValue | null>(null);
export const useAgentTableWorkspace = () => useContext(AgentTableContext);

/**
 * Just the row selection, for the per-row checkboxes. Its value changes only
 * when the selection or saving state does, so a live refresh (which rebuilds
 * the workspace value) does not re-render every checkbox in the table.
 */
export interface AgentSelectionValue {
  selected: Set<number>;
  saving: boolean;
  toggle: (rows: AgentPeriod[], checked: boolean) => void;
}
export const AgentSelectionContext = createContext<AgentSelectionValue | null>(null);
